<div class="command-palette-container">
  <div class="command-palette-header p-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-icon matPrefix>search</mat-icon>
      <input
        matInput
        placeholder="Search commands..."
        autocomplete="off"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
        autofocus>
    </mat-form-field>
  </div>

  <mat-divider></mat-divider>

  <div class="command-palette-content">
    <div class="command-list" *ngIf="allFilteredCommands.length > 0 || isSearchingEntities">
      <!-- Static Commands -->
      <div
        *ngFor="let command of filteredCommands; let i = index"
        class="command-item"
        [class.selected]="i === selectedIndex"
        (click)="executeCommand(command)"
        (mouseenter)="selectedIndex = i">
        <mat-icon class="command-icon">{{ command.icon }}</mat-icon>
        <div class="command-content">
          <span class="command-label">{{ command.label }}</span>
        </div>
        <mat-icon class="command-arrow">arrow_forward</mat-icon>
      </div>

      <!-- Entity Search Results -->
      <div class="command-section-divider" *ngIf="entityResults.length > 0 && filteredCommands.length > 0">
        <span class="section-label">Search Results</span>
      </div>

      <div
        *ngFor="let entity of entityResults; let j = index"
        class="command-item entity-result"
        [class.selected]="(filteredCommands.length + j) === selectedIndex"
        (click)="executeCommand(entity)"
        (mouseenter)="selectedIndex = filteredCommands.length + j">
        <mat-icon class="command-icon">{{ entity.icon }}</mat-icon>
        <div class="command-content">
          <span class="command-label">{{ entity.label }}</span>
          <span class="command-subtitle" *ngIf="entity.subtitle">{{ entity.subtitle }}</span>
        </div>
        <mat-icon class="command-arrow">arrow_forward</mat-icon>
      </div>

      <!-- Loading indicator -->
      <div class="loading-indicator" *ngIf="isSearchingEntities">
        <mat-icon class="loading-icon">hourglass_empty</mat-icon>
        <span>Searching...</span>
      </div>
    </div>

    <div class="empty-state" *ngIf="allFilteredCommands.length === 0 && !isSearchingEntities">
      <mat-icon class="empty-icon">search_off</mat-icon>
      <p class="empty-text">No results found</p>
      <p class="empty-hint">Try a different search term</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div class="command-palette-footer p-2 d-flex justify-content-between align-items-center">
    <div class="keyboard-hints">
      <span class="hint"><kbd>↑↓</kbd> Navigate</span>
      <span class="hint"><kbd>↵</kbd> Select</span>
      <span class="hint"><kbd>Esc</kbd> Close</span>
    </div>
    <button mat-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

